// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Rbmp","top":"styles_top__I7DKv"};